import { render } from "./ReportBuilder.vue?vue&type=template&id=72fedb86&scoped=true"
import script from "./ReportBuilder.vue?vue&type=script&lang=js"
export * from "./ReportBuilder.vue?vue&type=script&lang=js"

import "./ReportBuilder.vue?vue&type=style&index=0&id=72fedb86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fedb86"]])

export default __exports__